<template>
  <q-card class="pallet" square flat bordered>
    <q-card-section class="q-pa-none" @click="showPalletDialog = true">
      <pallet-teaser :pallet="pallet" :name="name"/>
    </q-card-section>

    <q-card-section class="veneer-log-info-section q-py-none">
      <pallet-info :pallet="pallet"/>
    </q-card-section>

    <slot name="additionalInfo"/>

    <q-separator/>

    <div class="row justify-start q-col-gutter-sm q-pa-sm veneer-card-buttons">
      <div class="col-4">
        <q-btn text-color="primary"
               size="11px"
               @click="showPalletDialog = true"
               icon="launch"
               no-caps no-wrap flat
               :label="$t('button.palletLogs')"
        />
      </div>
    </div>

    <pallet-dialog :visible="showPalletDialog" @hide="showPalletDialog = false" :name="name" :pallet="pallet"/>
  </q-card>
</template>

<script>
import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";
import PalletTeaser from "@/components/common/element/PalletTeaser";
import PalletInfo from "@/components/common/pallet/PalletInfo";
import PalletLogListDialogOpener from "@/mixins/PalletLogListDialogOpener";
import PalletDialog from "@/components/common/pallet/PalletDialog";

export default {
  name: "Pallet",
  components: {PalletDialog, PalletInfo, PalletTeaser},
  mixins: [LogPropertiesResolver, PalletLogListDialogOpener],
  props: ["pallet"],
  data() {
    return {
      showPalletDialog: false
    }
  },
  computed: {
    name() {
      return this.pallet.name || `${this.$t('pallet')} ${this.palletNo}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.pallet {
  transition: box-shadow 0.5s ease;
  max-width: 600px;
  margin: 0 auto;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.9) !important;
  }

  a {
    cursor: pointer;
  }

  .veneer-card-buttons i,
  .veneer-card-buttons img {
    margin-right: 4px;
  }
}

.pallet-log-list {
  background-color: var(--color-background);
}
</style>